import React, {useState} from "react";
import MyRouter from "routers";
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "./configs/firebase-config";
import {AuthContext} from "./global/AuthContext";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
function App() {
  const [isAuth, setIsAuth] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  onAuthStateChanged(auth, (user) => {
    if (user){
      setIsAuth(true);
      setIsVerified(user.emailVerified);
    }
  })

  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <ToastContainer />
      <AuthContext.Provider value={{setIsVerified, setIsAuth}}>
        <MyRouter isAuth={isAuth} isVerified={isVerified}/>
      </AuthContext.Provider>
    </div>
  );
}

export default App;
